// Copyright (c) 2026 CTO's Club LLC. All rights reserved.

export const PASSWORDLESS_LOGIN_EMAIL_STORAGE_KEY =
    'anchorbase.passwordless-login.email';
